import { Modal, ModalContent, ModalBody, useDisclosure, Button, ModalHeader, ModalFooter } from "@nextui-org/react";
import Camera from "./Camera";
import { useEffect, useState } from "react";
import { wallImages } from "../../api-route/wall-image";
import { BaseURL } from "../../config/axios";
import CanvasComponentContent from "./CanvasComponentContent";


const WallImage = ({ mainImage, size }) => {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [rooms, setRooms] = useState()
    const [bg, setBg] = useState()

    useEffect(() => {
        const get = async () => {
            const data = await wallImages()
            setRooms(data.data)
            setBg(BaseURL + data.data[0].image.path)
        }
        get()
    }, [])
    const handleLocalImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBg(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    return (
        <>
            <button onClick={onOpen} className="bg-primary text-white rounded-md p-3 flex  flex-items-center justify-between gap-3 hover:opacity-80">
                <img alt="دکراتیو" src="/images/art-icon/icon-room.png" />
                <span>نمایش تصویر در یک اتاق</span>
            </button>

            <Modal size={"5xl"} isOpen={isOpen} scrollBehavior={'inside'} onOpenChange={onOpenChange}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader />
                            <ModalBody>
                                <div className="grid grid-cols-5 grow">
                                    <div className="sm:flex hidden flex-col items-center pr-2 overflow-y-auto overflow-x-hidden max-h-[531px] col-span-1 gap-1">
                                        {rooms.map((w, index) => {
                                            return (
                                                <div key={index} className="centerOfParent cursor-pointer h-full w-full" onClick={() => setBg(BaseURL + w.image?.path)}>
                                                    <img
                                                        src={BaseURL + w.image?.path}
                                                        alt={w.title}
                                                        width={100} height={100}
                                                        style={{ width: '100%', height: '100%' }}
                                                    />
                                                </div>
                                            )
                                        })}
                                        <div>
                                            <Button className="w-full" title="درصورت تمایل، میتوانید تصویر پس زمینه دلخواه خود را بارگذاری کنید">
                                                <label className="w-full h-full centerOfParent cursor-pointer" htmlFor="inputFile" onChange={handleLocalImage}>
                                                    انتخاب از گالری
                                                    <input onChange={handleLocalImage} hidden
                                                        type="file" id='inputFile'
                                                        accept='image/jpeg, image/jpg, image/png, image/webp' />
                                                </label>
                                            </Button>
                                        </div>
                                    </div>
                                    <CanvasComponentContent bg={bg}
                                        overlay={mainImage} size={size} />
                                </div>
                                <div className="sm:hidden block">
                                    <Camera overlay={mainImage} size={size} />
                                </div>
                            </ModalBody>
                            <ModalFooter />
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default WallImage;